import client from '@/lib/axios-client'
import type {
	CalibrationDrilldownResult,
	CalibrationOrigin,
	DDSAttendanceDrilldown,
	InteracaoPersonDrillOutput,
	InteracaoPersonRole,
	KpiDDSOutput,
	KpiDirecionadaOutput,
	KpiFreeTextOutput,
	KpiFreeTextTableParams,
	KpiInteracaoOutput,
	KpiMetricsOutput,
	KpiMetricsParams,
	KpiVereAgirOutput,
	QuizQuestionDrillEntry,
} from '@/types'

export async function getKpiMetrics(
	params?: KpiMetricsParams,
): Promise<KpiMetricsOutput> {
	const response = await client.get('/kpi-metrics', { params })
	return response.data.data
}

export async function getVereAgirMetrics(
	params?: KpiMetricsParams,
): Promise<KpiVereAgirOutput> {
	const response = await client.get('/kpi-metrics/vereagir', { params })
	return response.data.data
}

export async function getDirecionadaMetrics(
	params?: KpiMetricsParams,
): Promise<KpiDirecionadaOutput> {
	const response = await client.get('/kpi-metrics/direcionada', { params })
	return response.data.data
}

export async function getInteracaoMetrics(
	params?: KpiMetricsParams,
): Promise<KpiInteracaoOutput> {
	const response = await client.get('/kpi-metrics/interacao', { params })
	return response.data.data
}

export async function getInteracaoPersonDrilldown(
	personId: string,
	role: InteracaoPersonRole,
	params?: KpiMetricsParams,
): Promise<InteracaoPersonDrillOutput> {
	const response = await client.get(
		`/kpi-metrics/interacao/${personId}/${role}`,
		{ params },
	)
	return response.data.data
}

export async function getDdsMetrics(
	params?: KpiMetricsParams,
): Promise<KpiDDSOutput> {
	const response = await client.get('/kpi-metrics/dds', { params })
	return response.data.data
}

export async function getCalibrationDrilldown(
	personId: string,
	origin: CalibrationOrigin,
	params?: KpiMetricsParams,
): Promise<CalibrationDrilldownResult> {
	const response = await client.get(
		`/kpi-metrics/calibration/${personId}/${origin}`,
		{ params },
	)
	return response.data.data
}

export async function getQuizQuestionsDrilldown(
	quizId: string,
	params?: KpiMetricsParams,
): Promise<QuizQuestionDrillEntry[]> {
	const response = await client.get(
		`/kpi-metrics/direcionada/quiz/${quizId}/questions`,
		{
			params,
		},
	)
	return response.data.data
}

export async function getDdsAttendanceDrilldown(
	crId: string,
	params?: KpiMetricsParams,
): Promise<DDSAttendanceDrilldown> {
	const response = await client.get(`/kpi-metrics/dds/attendance/${crId}`, {
		params,
	})
	return response.data.data
}

export async function exportDdsAttendance(
	crId: string,
	params?: KpiMetricsParams,
): Promise<Blob> {
	const response = await client.get(
		`/kpi-metrics/dds/attendance/${crId}/export`,
		{ params, responseType: 'blob' },
	)
	return response.data
}

export async function getFreeTextMetrics(
	params?: KpiMetricsParams & KpiFreeTextTableParams,
): Promise<KpiFreeTextOutput> {
	const response = await client.get('/kpi-metrics/free-text', { params })
	return response.data.data
}

export interface ExportDirecionadaParams {
	format: 'xlsx' | 'csv'
	kind?: 'CHECKLIST' | 'FREE_TEXT'
	quizId?: string
	branchId?: string
	crId?: string
	startDate?: string
	endDate?: string
}

export async function exportDirecionadaAnswers(
	params: ExportDirecionadaParams,
): Promise<Blob> {
	const response = await client.get('/direcionadas/export', {
		params,
		responseType: 'blob',
	})
	return response.data
}
